import React from 'react';
import { Button, TextInput, Dialog, DialogTitle, DialogContent } from 'design-system';
import { makeStyles } from 'react-scale/components/design-system/styles';

interface DescriptionModalProps {
  modalOpen: boolean;
  setModalOpen: (arg: boolean) => void;
  changeDescription: string;
  setChangeDescription: (arg: string) => void;
}

const DescriptionModal: React.FC<DescriptionModalProps> = ({
  modalOpen,
  setModalOpen,
  changeDescription,
  setChangeDescription,
}) => {
  const classes = useStyles();

  const close = (event?: any) => {
    // prevent ESC from closing modal
    if (event?.type === 'keydown' && event?.keyCode === 27) return;

    setModalOpen(false);
  };

  return (
    <>
      <Dialog
        classes={{ root: classes.dialogRoot, paper: classes.dialog }}
        open={modalOpen}
        onClose={close}
      >
        <DialogTitle>
          <div
            style={{ textAlign: 'center', fontWeight: 500, fontSize: '16px', lineHeight: '20px' }}
          >
            Provide a brief summary of changes for labelers (optional)
          </div>
        </DialogTitle>
        <DialogContent>
          <div className={classes.container}>
            <TextInput
              size="large"
              fullWidth
              placeholder="Brief summary of changes"
              label="Description"
              value={changeDescription}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setChangeDescription(e.target.value);
              }}
            />
            <div className={classes.createButton}>
              <Button type="primary" onClick={close}>
                Confirm
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dialog: {
    width: '500px',
    overflow: 'hidden',
    margin: '2% auto 20px',
  },
  dialogRoot: {
    zIndex: '110 !important' as any,
  },
  createButton: {
    paddingTop: '15px',
  },
});

export default DescriptionModal;
